import EventBus from '../lib/event-bus'
import Events from '../lib/events'

export default {
    name: 'scroll-bottom',

    bind: (el, binding, vnode) => {
        el.scrollBottomEvent = (e) => {
            const closestScrollEl = el.closest(e.scrollSelector)

            if (e.scrollEl === closestScrollEl) {
                vnode.context[binding.expression]()
            }
        }

        EventBus.$on(Events.SCROLL_BOTTOM, el.scrollBottomEvent)
    },

    unbind: (el) => {
        EventBus.$off(Events.SCROLL_BOTTOM, el.scrollBottomEvent)
    },
}
